<label *ngIf="isShowLabel" translate>{{ labelName }}</label>
<div class="date-picker" [ngClass]="{'isnotallowed': isDisabled()}">
  <mat-icon class="md-18 clickable"
            [class.next-prev-error]="hasCalendarDateError()"
            id="{{Id}}-prev-day"
            (click)="setPrevDay()">chevron_left
  </mat-icon>

  <div class="calendar-box"
       [ngClass]="{'has-error': hasCalendarDateError()}">
    <span class="toggle-box no-border-right">
      <button type="button" class="btn btn-flush toggle-btn toggle-day-of-week-button"
              [disabled]="isDisabled()"
              (click)="calendarDatePicker.toggle()">{{dayOfWeek}}
      </button>
    </span>
    <div class="input-box">
      <input type="text"
             #calendarDatePicker="bsDatepicker"
             bsDatepicker
             class="form-control tile-calendar"
             [class.tile-field-invalid-submitted]="hasCalendarDateError()"
             id="{{Id}}-input"
             name="calendarDatePicker"
             [bsValue]="selectedCalendarDate"
             [dateCustomClasses]="dateCustomClasses"
             [bsConfig]="bsConfig"
             [maxDate]="maxDate"
             [minDate]="minDate"
             (bsValueChange)="onCalendarDateChange($event)"
             (onShown)="attachTodayButtonHandler()"
             [readonly]="false"
             [disabled]="isDisabled()"
             [placement]="'top'">
      <div class="incorrect-input datepicker-next-prev-error"
           *ngIf="hasCalendarDateError()"
           id="{{Id}}-error">
        <sup></sup>{{calendarDateError}}
        <br>
      </div>
    </div>
    <span class="toggle-box no-border-left">
      <button type="button" class="btn btn-flush toggle-btn toggle-calendar-button"
              [disabled]="isDisabled()"
              (click)="calendarDatePicker.toggle()">
        <mat-icon class="md-18"
                  id="{{Id}}-calendar-btn">calendar_today
        </mat-icon>
      </button>
    </span>
  </div>

  <mat-icon class="md-18 clickable"
            [class.next-prev-error]="hasCalendarDateError()"
            id="{{Id}}-next-day"
            (click)="setNextDay()">chevron_right
  </mat-icon>
</div>
